/** 足行天下 API 配置 - 作者: zbq, 日期: 2026-05-29 */

/** 参考 app 线上地址 */
export const ZQ_API_ORIGIN = 'https://zuqiu.zljltt.com';

/**
 * 开发环境 API 根路径。
 * 手机局域网访问时需用当前页面的 origin（如 http://192.168.x.x:5173/zq-api/），
 * 否则相对路径 /zq-api/ 在部分机型上图标、接口会异常。
 */
export function getZqApiBase() {
  const prodBase = import.meta.env?.VITE_ZQ_API_BASE;
  if (prodBase) {
    const base = prodBase.endsWith('/') ? prodBase : `${prodBase}/`;
    if (base.startsWith('/') && typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}${base}`;
    }
    return base;
  }
  if (typeof import.meta !== 'undefined' && import.meta.env?.DEV) {
    const lan = import.meta.env.VITE_ZQ_LAN_API;
    if (lan) {
      return lan.endsWith('/') ? lan : `${lan}/`;
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}/zq-api/`;
    }
    return '/zq-api/';
  }
  // 生产 H5：默认同源 /zq-api/（支持 IP / 域名访问，勿写死外站）
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/zq-api/`;
  }
  return `${ZQ_API_ORIGIN}/apis/`;
}

/** @deprecated 请用 getZqApiBase()；保留兼容 */
export const zqBaseUrl = getZqApiBase();
